import { createServer } from 'miragejs';
import accountsMe from './accounts.me';
import metricsMetadata from './metrics.metadata';
import metricsGraph from './metrics.graph';
import usageData from './usage.data';
import { API_GATEWAY_URI } from '../common/consts';
import { ACCOUNTS_ROUTES } from '../common/clients/accounts.service';
import { METRICS_ROUTES } from '../common/clients/metrics.service';
import { USAGE_ROUTES } from '../common/clients/usage.service';

export function makeMockServer({ environment = 'development' } = {}) {
  const server = createServer({
    environment,
    routes() {
      this.passthrough('https://api.github.com/*', {});

      this.timing = environment === 'test' ? 0 : 800;

      this.get(`${API_GATEWAY_URI}${ACCOUNTS_ROUTES.ME}`, () => {
        return accountsMe;
      });

      this.get(
        `${API_GATEWAY_URI}${ACCOUNTS_ROUTES.SWITCH_ORG}`,
        (schema, request) => {
          return accountsMe;
        }
      );

      this.get(`${API_GATEWAY_URI}${METRICS_ROUTES.METADATA}`, async () => {
        return metricsMetadata;
      });

      this.get(
        `${API_GATEWAY_URI}${METRICS_ROUTES.GRAPH}`,
        (schema, request) => {
          return metricsGraph[request.queryParams.periodName];
        }
      );

      this.get(`${API_GATEWAY_URI}${USAGE_ROUTES.USAGE_DATA}`, async () => {
        return usageData;
      });

      // Do not mock these following routes:

      // Analytics
      this.passthrough('https://cdn.segment.com/*', {});
      this.passthrough('https://app.launchdarkly.com/*', {});
      this.passthrough('https://clientstream.launchdarkly.com/*', {});
    }
  });

  return server;
}
